<template>
  <footer class="footer" role="contentinfo">
    <div class="footer__wrapper">
      <section class="footer__top">
        <div>
          <div class="footer__logo">
            <IneLogo
              class="footer__logo-img"
              title="Experts at making you an expert"
            />
          </div>
          <p class="footer__tagline">Experts at making you an expert</p>
        </div>
        <div class="footer__links">
          <div class="footer__category" v-if="isAuthenticated">
            <h6 class="footer__category-title">Helpful Links</h6>
            <nav class="footer__nav">
              <router-link
                class="footer__link"
                :to="{
                  name: 'user-dashboard',
                  params: { mode: 'active-courses' },
                }"
                >Active Courses</router-link
              >
              <router-link
                class="footer__link"
                :to="{ name: 'user-dashboard', params: { mode: 'bookmarks' } }"
                >Bookmarks</router-link
              >
              <router-link
                class="footer__link"
                :to="{ name: 'user-dashboard', params: { mode: 'profile' } }"
                >Profile</router-link
              >
            </nav>
          </div>
          <div v-show="!isCordova" class="footer__category">
            <h6 class="footer__category-title">Service</h6>
            <nav class="footer__nav">
              <a
                class="footer__link"
                target="_blank"
                href="//ine.com/pages/contact-us"
                >Support</a
              >
              <a
                class="footer__link"
                target="_blank"
                href="//ine.com/products/team-training-1-year"
                >Sales</a
              >
              <a class="footer__link" target="_blank" href="//careers.ine.com/"
                >Careers</a
              >
              <!-- <button
								class="footer__link"
								@click="showFeedbackModal"
							>Feedback</button> -->
              <a
                class="footer__link"
                target="_blank"
                href="//ine.com/pages/contact-us"
                >Feedback</a
              >
            </nav>
          </div>
          <div v-show="!isCordova" class="footer__category">
            <h6 class="footer__category-title">Connect</h6>
            <nav class="footer__social-nav">
              <a
                class="footer__social-link"
                target="_blank"
                href="//www.linkedin.com/company/ine-inc/"
              >
                <SocialLinkedin class="footer__social-icon"></SocialLinkedin>
              </a>
              <a
                class="footer__social-link"
                target="_blank"
                href="//www.youtube.com/user/INEtraining"
              >
                <SocialYoutube class="footer__social-icon"></SocialYoutube>
              </a>
              <br />
              <a
                class="footer__social-link"
                target="_blank"
                href="//twitter.com/ine"
              >
                <SocialTwitter class="footer__social-icon"></SocialTwitter>
              </a>
              <a
                class="footer__social-link"
                target="_blank"
                href="//www.facebook.com/inetraining/"
              >
                <SocialFacebook class="footer__social-icon"></SocialFacebook>
              </a>
            </nav>
          </div>
        </div>
      </section>
      <section v-show="!isCordova" class="footer__bottom">
        <p class="footer__copyright">
          &copy; 2019 INE. All Rights Reserved ::
          <a
            title="Terms of Service"
            target="_blank"
            href="//checkout.shopify.com/17217507/policies/16723909.html"
            >Terms of Service</a
          >
          ::
          <a
            title="Privacy Policy"
            target="_blank"
            href="https://checkout.shopify.com/17217507/policies/16723845.html"
            >Privacy Policy</a
          >
        </p>
      </section>
      <div class="footer__bg-image">
        <!-- <img src="@/assets/images/footer/bg_ine_footer@2x.png" /> -->
        <img :src="footerImage" />
      </div>
    </div>
    <div class="footer__gradient"></div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import SocialFacebook from '@/assets/icons/social/social-facebook.svg'
import SocialLinkedin from '@/assets/icons/social/social-linkedin.svg'
import SocialTwitter from '@/assets/icons/social/social-twitter.svg'
import SocialYoutube from '@/assets/icons/social/social-youtube.svg'
import IneLogo from '@/assets/images/ine-logo.svg'

export default {
  name: 'Footer',
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      isCordova: 'app/isCordova',
    }),
    footerImage() {
      return 'https://s3.amazonaws.com/my.ine.com/assets/bg_ine_footer%402x.png'
    },
  },
  components: {
    SocialFacebook: { ...SocialFacebook, name: 'SocialFacebook' },
    SocialLinkedin: { ...SocialLinkedin, name: 'SocialLinkedin' },
    SocialTwitter: { ...SocialTwitter, name: 'SocialTwitter' },
    SocialYoutube: { ...SocialYoutube, name: 'SocialYoutube' },
    IneLogo: { ...IneLogo, name: 'IneLogo' },
  },
  methods: {
    showFeedbackModal() {
      const doorbellModal = document.querySelector('#doorbell')
      const doorbellModalBackground = document.querySelector(
        '#doorbell-background'
      )
      doorbellModal.setAttribute('style', 'display: block; position: fixed;')
      doorbellModalBackground.setAttribute(
        'style',
        'display: block; position: fixed;'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  $this: &;
  position: relative;
  z-index: 1;
  &__wrapper {
    padding: 20px 32px;
    position: relative;
    z-index: 400;
    background: var(--black);
    overflow: hidden;
    @media screen and (min-width: 1024px) {
      padding: 40px 64px;
    }
    @media screen and (min-width: 1200px) {
      padding: 50px 130px;
    }
  }
  &__top {
    padding: 30px 0;
    position: relative;
    z-index: 400;
    @media screen and (min-width: 767px) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 50px 0;
    }
  }
  &__logo {
    margin: 0 0 20px 0;
    @media screen and (min-width: 767px) {
      margin: 0 0 65px 0;
    }
  }
  &__logo-img {
    width: 164px;
    height: auto;
  }
  &__tagline {
    color: var(--white);
    text-transform: uppercase;
    font-family: var(--font-medium);
    font-style: italic;
    font-size: (18 / 16) * 1rem;
    margin: 0;
    width: 100%;
    max-width: 200px;
    margin: 0 0 40px 0;
    @media screen and (min-width: 767px) {
      margin: 0;
    }
  }
  &__links {
    display: flex;
    align-items: flex-start;
    width: 100%;
    max-width: 400px;
    flex-wrap: wrap;
    @media screen and (min-width: 1200px) {
      max-width: 540px;
    }
  }
  &__category {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: (100 / 2) * 1%;
    padding: 0 20px 0 0;
    &:last-child {
      padding: 0;
      flex-basis: 100%;
      margin: 20px 0 0 0;
    }
    @media screen and (min-width: 450px) {
      flex-basis: (100 / 3) * 1%;
      &:last-child {
        flex-basis: (100 / 3) * 1%;
        margin: 0;
      }
    }
  }
  &__category-title {
    color: var(--orange);
    font-size: (14 / 16) * 1rem;
    text-transform: uppercase;
    margin: 0 0 15px 0;
    font-family: var(--font-medium);
  }
  &__social-nav {
    br {
      display: none;
    }
    @media screen and (min-width: 450px) {
      br {
        display: block;
      }
    }
  }
  &__social-link {
    display: inline-block;
    font-size: 0;
    margin: 0 10px 10px 0;
    &:hover {
      #{$this}__social-icon {
        fill: var(--orange);
      }
    }
    &:last-child {
      margin: 0;
    }
  }
  &__social-icon {
    width: 36px;
    height: 36px;
    fill: #777;
    transition: fill 0.15s ease;
  }
  &__link {
    display: block;
    color: var(--white);
    text-decoration: underline;
    font-size: (14 / 16) * 1rem;
    margin: 0 0 20px 0;
    transition: padding 0.15s ease;
    background: 0;
    padding: 0;
    appearance: none;
    border: none;
    font-family: var(--font-medium);
    &:hover {
      padding: 0 0 0 4px;
    }
    &:last-child {
      margin: 0;
    }
  }
  &__bottom {
    border-top: 1px solid var(--light-gray);
    padding: 25px 0 0;
    position: relative;
    z-index: 400;
  }
  &__copyright {
    font-family: var(--font-medium);
    font-size: (14 / 16) * 1rem;
    color: #555555;
    a {
      color: #555555;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__gradient {
    height: 36px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    transform: translateY(-10px);
    background: radial-gradient(var(--orange) 0, transparent 60%);
    z-index: 200;
  }
  &__bg-image {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 130px;
    z-index: 300;
    max-width: 1340px;
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
